var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5001 20.8C17.3603 20.8 21.3002 16.8601 21.3002 11.9999C21.3002 7.1397 17.3603 3.19976 12.5001 3.19976C7.63995 3.19976 3.7 7.1397 3.7 11.9999C3.7 16.8601 7.63995 20.8 12.5001 20.8ZM12.5001 22C18.023 22 22.5002 17.5228 22.5002 11.9999C22.5002 6.47696 18.023 1.99976 12.5001 1.99976C6.97721 1.99976 2.5 6.47696 2.5 11.9999C2.5 17.5228 6.97721 22 12.5001 22Z",
    fill: "#F573A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.566 17.1C12.2346 17.1 11.966 16.8314 11.966 16.5L11.966 9.50004C11.966 9.16867 12.2346 8.90004 12.566 8.90004C12.8974 8.90004 13.166 9.16867 13.166 9.50004L13.166 16.5C13.166 16.8314 12.8974 17.1 12.566 17.1Z",
    fill: "#F573A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.966 6.90006C11.966 6.56869 12.2346 6.30006 12.566 6.30006C12.8974 6.30006 13.166 6.56869 13.166 6.90006C13.166 7.23143 12.8974 7.50006 12.566 7.50006C12.2346 7.50006 11.966 7.23143 11.966 6.90006Z",
    fill: "#F573A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.538c9d48292e1980b918c9fdfdb45b85.svg";
export { ForwardRef as ReactComponent };